import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface RoomCardProps {
  room: {
    type: string;
    image: string;
    id: string;
  };
  onViewDetails?: () => void;
}

export default function RoomCard({ room, onViewDetails }: RoomCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    if (onViewDetails) {
      onViewDetails();
    } else {
      navigate(`/room/${room.id}`);
    }
  };

  return (
    <div
      className="group bg-white rounded-xl shadow-md hover:shadow-2xl overflow-hidden cursor-pointer transition-all duration-300"
      onClick={handleClick}
    >
      <div className="relative h-64 overflow-hidden">
        <img
          src={room.image}
          alt={room.type}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <h3 className="text-2xl font-serif font-semibold text-white mb-2">{room.type}</h3>
          <span className="inline-flex items-center gap-2 text-white text-sm font-medium bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full group-hover:bg-white/30 transition-colors">
            {t('rooms.details.viewDetails')}
            <span className="text-lg group-hover:translate-x-1 transition-transform">→</span>
          </span>
        </div>
      </div>
    </div>
  );
}
